import axios from 'axios';
import store from '@/store';
import router from '../router';
import Constants from '@/constants.js';
export const baseURL = `${Constants.API_URL}/api/v`;
// export const baseURL = `http://192.168.6.131:3000/api/v`;
export function apiClient(options = {}) {
  let user;
  if (store.state.user.user) {
    user = store.state.user.user.jwt;
  }

  const { apiVer, isFile, ...axiosConf } = options;

  const config = {
    baseURL: baseURL + (apiVer || 1),
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...axiosConf,
      Authorization: `Bearer ${user}`,
    },
  };
  if (isFile) {
    config['responseType'] = 'arraybuffer';
  }
  return axios.create(config);
}

export async function handleResp(action, isHandleError = true) {
  try {
    const dataRet = await action;
    return dataRet.data;
  } catch (ex) {
    if (isHandleError && ex.response && ex.response.status === 401) {
      router.push({ name: 'signIn' });
    }
    throw ex;
  }
}
